// extracted by mini-css-extract-plugin
export default {"wrapper":"kr-z","response":"lr-z","error":"mr-z","disabled":"nr-z","buttons":"or-z","feedbackQuestionSection":"pr-z","yesNoWrapper":"qr-z"};